/**
 * IFD Cart Add-on Sync
 * Keeps the subscription product and its add-on ("subscription fee")
 * line item linked in the cart:
 * - Removing the subscription product also removes the add-on.
 * - Removing the add-on also removes the subscription product.
 * Add-on lines are tagged with the `_ifd_addon` line item property
 * (see ifd-subscription-widget.js) and hidden in the cart display.
 */
(function () {
  'use strict';

  let syncing = false;
  let lastHadPair = false;

  function isSubscriptionItem(item) {
    return !!item.selling_plan_allocation;
  }

  function isAddonItem(item) {
    return !!(item.properties && item.properties._ifd_addon);
  }

  function removeByKey(key) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
  }

  function refreshCartUI() {
    const cartDrawer = document.querySelector('cart-drawer');
    const cartItems = document.querySelector('cart-items');
    if (cartDrawer && typeof cartDrawer.refresh === 'function') {
      cartDrawer.refresh();
    } else if (cartItems && typeof cartItems.refresh === 'function') {
      cartItems.refresh();
    }

    fetch(`${window.location.pathname}?sections=cart-icon-bubble`)
      .then((response) => (response.ok ? response.json() : null))
      .then((data) => {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && data && data['cart-icon-bubble']) {
          bubble.innerHTML = data['cart-icon-bubble'];
        }
      })
      .catch(() => {});
  }

  async function sync() {
    if (syncing) return;
    syncing = true;

    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return;
      const cart = await response.json();

      const subscriptions = cart.items.filter(isSubscriptionItem);
      const addons = cart.items.filter(isAddonItem);
      const toRemove = [];

      if (addons.length && !subscriptions.length) {
        // Subscription was removed: remove the orphaned add-on(s)
        addons.forEach((item) => toRemove.push(item.key));
      } else if (subscriptions.length && !addons.length && lastHadPair) {
        // Add-on was removed: remove the subscription product too
        subscriptions.forEach((item) => toRemove.push(item.key));
      }

      lastHadPair = subscriptions.length > 0 && addons.length > 0;

      if (toRemove.length) {
        // Removals change line indexes, so remove by key sequentially
        for (let i = 0; i < toRemove.length; i += 1) {
          await removeByKey(toRemove[i]); // eslint-disable-line no-await-in-loop
        }
        lastHadPair = false;
        refreshCartUI();
      }
    } catch (error) {
      // Never break the cart over sync issues
    } finally {
      syncing = false;
    }
  }

  const scheduleSync = () => setTimeout(sync, 300);

  ['on:line-item:change', 'on:cart:add'].forEach((eventName) => {
    document.addEventListener(eventName, scheduleSync);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }
})();
